import { Formik, FormikProps } from 'formik';
import { Guid } from 'guid-typescript';
import Moment from 'moment';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import ActivitySettings from '../../../../components/add-activity/activity-settings';
import SelectClasses from '../../../../components/add-activity/select-classes';
import Loading from '../../../../components/loading/loading';
import { Notification } from '../../../../components/notification/main';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { IAction, IAppState } from '../../../../models/action/core';
import { IInformationNoteData } from '../../../../models/action/informationNote';
import { IAddInformationNote } from '../../../../models/components/add-activity';
import { getValidation } from '../../../../models/validations/activity-information-note-validation';
import * as Actions from '../../../../store/actions/informationNote';
import InformationNoteActivityContent from './content';
import { ActivityType, ActivityTypeEnums } from '../../../../models/enums/ActivityType';
import { initSubmitValuesForApi, checkFileUploadEmpty } from '../../../../components/add-activity/add-activity-functions';
import { Modal } from 'reactstrap';
import { IPreference } from '../../../../models/action/profile';
import AddActivityTabs from '../../../../components/add-activity/tabs';
import CAddActivityFooter from '../../../../components/add-activity/footer';
import { ISetAssignmentStudentList } from '../../../../models/action/assignment';

import { Log } from 'ng2-logger';
const _logger = Log.create('informationNote_add_modal');
const T = Translator.create();
let _common: Common;
const spinnerId = 'addInformationNoteLoading';

export class AddInformationNote extends React.Component<IAddInformationNote, any> {
    public modalRootDiv: HTMLElement | null = null;

    _selectClassTab = ['isCommon', 'selectedClass'];
    _contentTab = [
        'name',
        'fileUploaded',
        'activityTime',
        'selectActivity',
        'isFileUploadEmpty',
        'termWeekIds',
        'datePrerequisiteActivityId',
        'datePrerequisiteActivityHours',
        'description',
        'informationNoteActivityType'
    ];
    _projectActivity = ['name', 'fileUploaded', 'description'];

    constructor(props: any) {
        super(props);
        _common = new Common();
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            currentTab: !this.props.isProjectSubActivity && !this.props.isSingleClass && this.props.hasClass ? '_selectClassTab' : '_contentTab',
            validations: {},
            fileInputKey: Guid.create().toString(),
            photoUploadKey: Guid.create().toString(),
            isLoadingProcess: false
        };
    }

    public componentDidMount() {
        if (this.props.updateActivityId) {
            this.props.dispatch(
                Actions.updateInformationNoteGetAction(
                    {
                        GetActivityType: 1,
                        activityId: this.props.updateActivityId,
                        classId: this.props.coursePageClassId!,
                        courseId: this.props.coursePageActivityId!
                    },
                    spinnerId,
                    'get'
                )
            );
        }
    }

    onSubmit = (FormikValues: IInformationNoteData) => {
        this.setState({ isLoadingProcess: true })
        const values: IInformationNoteData = JSON.parse(JSON.stringify(FormikValues));
        initSubmitValuesForApi(this.props, values, ActivityTypeEnums.InformationNote);
        this.props.dispatch(Actions.addInformationNoteGetAction(values, spinnerId, 'get', this.callBackFunction));
    };

    callBackFunction = (value: any) => {
        if (!value) {
            this.setState({ isLoadingProcess: false });
            return;
        }
        if (this.props.isProjectSubActivity && this.props.activityCard) {
            value.termWeekId = this.props.activityCard.termWeekIds[0];
            value.isUpdateWeeks = false;
        } else {
            value.termWeekId = _common.findTermWeekIdForRefreshPage(this.props, value);
            value.isUpdateWeeks = true;
        }
        this.props.onRefreshActivityCards(value);
        this.setCloseModal();
        this.setState({ isLoadingProcess: false })
    };

    onTabChange = (values: FormikProps<any>, onClickNext: boolean, nextTab?: string, completeForm?: boolean) => {
        // tslint:disable-next-line: no-floating-promises
        this.validateTabAndChange(values, onClickNext, nextTab, completeForm);
    }

    validateTabAndChange = async (values: FormikProps<any>, onClickNext: boolean, nextTab?: string, completeForm?: boolean) => {
        values.values.isFileUploadEmpty = checkFileUploadEmpty();
        if (this.state.currentTab === nextTab) return;

        let allowChangeTab: boolean = true;
        const isUserGoingPreviousTab: boolean =
            this.state.currentTab === '_contentTab' && nextTab === '_selectClassTab' && !this.props.isProjectSubActivity;
        // tslint:disable-next-line

        if (values.values.datePrerequisiteActivityId.length > 0 && values.values.datePrerequisiteActivityId[0] === null) {
            values.values.datePrerequisiteActivityId = "";
        }
        const validations = await values.validateForm().then((result: any) => result);

        if (onClickNext) {
            this.state.currentTab === '_selectClassTab' ? (nextTab = '_contentTab') : (nextTab = '_activitySettingTab');
        }

        if (!isUserGoingPreviousTab && !completeForm) {


            switch (this.state.currentTab) {
                case '_selectClassTab': {
                    Object.keys(validations).forEach((validationKey: string) => {
                        if (this._selectClassTab.find(key => key === validationKey)) {
                            Notification.setNotification(
                                'error',
                                T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                                'topRight'
                            );
                            allowChangeTab = false;
                        }
                    });
                    break;
                }
                case '_contentTab': {
                    Object.keys(validations).forEach((validationKey: string) => {
                        if (this._contentTab.find(key => key === validationKey)) {
                            Notification.setNotification(
                                'error',
                                T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                                'topRight'
                            );
                            allowChangeTab = false;
                        }
                    });
                    break;
                }
                default: {
                    break;
                }
            }
        }

        if (completeForm) {
            let isCompleted: boolean = true;

            if (this.props.onCompleteValidateForm) {
                if (!this.props.onCompleteValidateForm(validations, this._projectActivity, this.props.isProjectSubActivity)) {
                    allowChangeTab = false;
                    isCompleted = false;
                }
            }
            if (isCompleted) {
                values.submitForm();
            }
        }

        if (allowChangeTab && nextTab) {
            this.setState({
                currentTab: nextTab
            });
        }
    };

    getValidation = () => {
        if (
            this.props.coursePageclassInformation &&
            this.props.coursePageclassInformation.isWeekly === true &&
            this.props.coursePageclassInformation.startDate &&
            this.props.coursePageclassInformation.endDate
        ) {
            return getValidation({
                isProjectSubActivity: this.props.isProjectSubActivity,
                startDate: this.props.coursePageclassInformation.startDate,
                endDate: this.props.coursePageclassInformation.endDate,
                dateFormat: _common.findDateFormat(this.props.userPreferences!),
            });
        } else {
            return getValidation({ isProjectSubActivity: this.props.isProjectSubActivity });
        }
    };

    setCloseModal = () => {
        this.props.dispatch(Actions.setInformationNoteDataDefault());
        this.props.setCloseModal(ActivityType.InformationNote);
    };

    triggerModal = (assignedStudentDatas: ISetAssignmentStudentList, removedStudentDatas: ISetAssignmentStudentList, currentTab: string) => { };

    selectedClassIds = (selectedClassIds: any) => { };

    setInitialFormValues = (userDateFormat: string) => {
        const initialFormValues = {
            ...this.props.informationNoteData!,
            activityBeginDate:
                this.props.informationNoteData!.activityConditionalBeginDate
                    ? Moment(this.props.informationNoteData!.activityConditionalBeginDate.toString())
                        .format(userDateFormat)
                        .toString()
                    : '',
            activityBeginTime:
                this.props.informationNoteData!.activityConditionalBeginDate
                    ? Moment(this.props.informationNoteData!.activityConditionalBeginDate).format('HH:mm')
                        .toString()
                    : '',
            activityEndDate:
                this.props.informationNoteData!.activityConditionalEndDate
                    ? Moment(this.props.informationNoteData!.activityConditionalEndDate.toString())
                        .format(userDateFormat)
                        .toString()
                    : '',
            activityEndTime:
                this.props.informationNoteData!.activityConditionalEndDate
                    ? Moment(this.props.informationNoteData!.activityConditionalEndDate).format('HH:mm')
                        .toString()
                    : '',
            fileInputKey: this.state.fileInputKey,
            photoUploadKey: this.state.photoUploadKey,
            fileUploaded: (this.props.informationNoteData && this.props.informationNoteData.file) ? true : false,
            isAllClass: this.props.updateActivityId && this.props.informationNoteData ? this.props.informationNoteData.isAllClass : this.props.isSingleClass,
            isActivityPrerequisite: this.props.informationNoteData!.prerequisiteActivityId && this.props.informationNoteData!.prerequisiteActivityId.length > 0,
            isCommon: this.props.informationNoteData!.isCommon
        };
        return initialFormValues;
    }

    public render() {
        const userDateFormat: string = _common.findDateFormat(this.props.userPreferences!);

        const initialFormValues = this.setInitialFormValues(userDateFormat);
        return (
            <Modal
                isOpen={this.props.isModalOpen}
                toggle={this.setCloseModal}
                modalClassName={'add-activity-modal modal-from-right slideInRight show animated'}
                fade={true}
                style={{ display: 'block', animationDuration: '0.5s' }}
                backdrop={'static'}
            >
                <div className="modal-dialog" role="document">
                    {(this.props.updateActivityId && initialFormValues.activityId) || !this.props.updateActivityId ? (
                        <div className="modal-content">
                            <Formik validationSchema={this.getValidation} initialValues={initialFormValues} onSubmit={this.onSubmit}>
                                {props => {
                                    return (
                                        <form onSubmit={props.handleSubmit} role="form">
                                            <div className="modal-header">
                                                <h5 className="modal-title d-flex align-items-center">
                                                    <i className="material-icons mr-2">{_common.GetMaterialActivityIcons(ActivityType.InformationNote)}</i>
                                                    <span>{this.props.updateActivityId ? T.t('r_edit_informationNote_activity') : T.t('r_add_informationNote_activity')}</span>
                                                </h5>
                                                <button
                                                    onClick={this.setCloseModal}
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="modal"
                                                    aria-label="Close"
                                                >
                                                    <i style={{ color: '#000' }} className="material-icons">
                                                        close
                                                    </i>
                                                    <span>{T.t('r_gen_close')}</span>
                                                </button>
                                            </div>
                                            <div className="modal-body p-0">
                                                <Loading width={100} spinnerId={spinnerId} />

                                                <AddActivityTabs
                                                    currentTab={this.state.currentTab}
                                                    formikProps={props}
                                                    validateTabAndChange={this.validateTabAndChange}
                                                    isProjectSubActivity={this.props.isProjectSubActivity}
                                                    isSingleClass={this.props.isSingleClass}
                                                    hasClass={this.props.hasClass}
                                                />
                                                <div className="tab-content" id="tabContent">
                                                    {
                                                        this.props.hasClass &&
                                                        <SelectClasses
                                                            coursePageActivityId={this.props.coursePageActivityId!}
                                                            currentTab={this.state.currentTab}
                                                            isUpdate={this.props.updateActivityId}
                                                            selectedClassIds={this.selectedClassIds}
                                                        />
                                                    }

                                                    <InformationNoteActivityContent
                                                        currentTab={this.state.currentTab}
                                                        isUpdate={this.props.updateActivityId}
                                                        fileInputKey={this.state.fileInputKey}
                                                        dateFormat={userDateFormat}
                                                        isWeekly={
                                                            this.props.coursePageclassInformation &&
                                                                this.props.coursePageclassInformation.isWeekly
                                                                ? this.props.coursePageclassInformation.isWeekly
                                                                : false
                                                        }
                                                        termType={this.props.termType ?? T.t('r_time_week')}

                                                        coursePageActivityId={this.props.coursePageActivityId!}
                                                        coursePageClassId={this.props.coursePageClassId!}
                                                        isProjectSubActivity={this.props.isProjectSubActivity}
                                                        activityType={ActivityType.InformationNote}
                                                    />
                                                    <ActivitySettings
                                                        removedStudentDatas={{ users: [], filters: {}, type: '', timestamp: 0 }}
                                                        assignedStudentDatas={{ users: [], filters: {}, type: '', timestamp: 0 }}
                                                        isActivityCardShown={false}
                                                        currentTab={this.state.currentTab}
                                                        coursePageActivityId={this.props.coursePageActivityId!}
                                                        coursePageClassId={this.props.coursePageClassId!}
                                                        displayAllowDownloadSetting={false}
                                                        setCloseModal={this.triggerModal}
                                                        triggerModal={this.triggerModal}
                                                        isUpdate={this.props.updateActivityId}
                                                        activityType={ActivityType.InformationNote}
                                                    />
                                                </div>

                                            </div>
                                            <CAddActivityFooter
                                                currentTab={this.state.currentTab}
                                                formikProps={props}
                                                spinnerId={spinnerId}
                                                validateTabAndChange={this.validateTabAndChange}
                                                isProjectSubActivity={this.props.isProjectSubActivity}
                                                setCloseModal={this.setCloseModal}
                                                isLoadingProcess={this.state.isLoadingProcess}
                                            />
                                        </form>
                                    );
                                }}
                            </Formik>
                        </div>
                    ) : null}{' '}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddInformationNote): IAddInformationNote => {
    if (!state) {
        return ownProps;
    }

    const InformationNoteObject: any = state.informationNote;

    const newProps: IAddInformationNote = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        informationNoteData: InformationNoteObject.InformationNoteData,
        initialTermWeekId: state.coursePage.courseContentTermWeeks && state.coursePage.courseContentTermWeeks[0].termWeekId,
        userPreferences: state.profile.userPreferences.preferences,
        termType: state.coursePage.courseContentTermWeeks?.[1]?.termType ?? null,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.informationNote.InformationNoteData === prev.informationNote.InformationNoteData;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CAddInformationNote = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(AddInformationNote);

export default CAddInformationNote;
